import Vue from 'vue';
import jQuery from 'jquery';
import fastclick from 'fastclick';
import tippy from 'tippy.js';
import foundation from 'foundation-sites';
import 'foundation-sites/js/foundation/foundation.dropdown';
import 'foundation-sites/js/foundation/foundation.equalizer';
import 'foundation-sites/js/foundation/foundation.tab';
import 'foundation-sites/js/foundation/foundation.accordion';
import 'promise-polyfill/src/polyfill';

import './helpers/_iePolyfills';

import './plugins/modernizr-min';
import './plugins/responsive-tables';
import './plugins/list.min';
import './plugins/nouislider';
// import './plugins/detectizr';
import './plugins/history.js/scripts/bundled/html4+html5/jquery.history';
import './plugins/jquery.selectric';
import './plugins/js.cookie.js';
import './plugins/jquery.autocomplete';

import './plugins/royalslider/jquery.royalslider';
import './plugins/royalslider/modules/jquery.rs.active-class';
import './plugins/royalslider/modules/jquery.rs.animated-blocks';
import './plugins/royalslider/modules/jquery.rs.auto-height';
import './plugins/royalslider/modules/jquery.rs.autoplay-custom';
import './plugins/royalslider/modules/jquery.rs.bullets';
import './plugins/royalslider/modules/jquery.rs.global-caption';
import './plugins/royalslider/modules/jquery.rs.nav-auto-hide';
import './plugins/royalslider/modules/jquery.rs.tabs';
import './plugins/royalslider/modules/jquery.rs.thumbnails';
import './plugins/royalslider/modules/jquery.rs.video';
import './plugins/royalslider/modules/jquery.rs.visible-nearby';

import './_globals';
import './_vhUnitFix';
import './_homepage';
import './_scrollToElement';
import './_accordion';
import './_mobileMenu';
import './_primaryNav';
import './_slideshows';
import './_sticky';
import './_compact_nav';
import './_sidebar';
import './_childTabs';
import './_singlePerson';
import './_backgroundVideo';
import './_request_a_loan';
import './_private_banking';
import './_externalLinks';
import './_overlayBox';
import './_funds';
import './_loanCalculator';
import './_carousell';
import './_csrf';
import './_100years';
import './_objectfitFallback';
import './_currencyConverter';
import './_formieForms';
import InitChat from './_chat';
import LoanApplicationForm from './components/loanapplication/LoanApplicationForm';

global.$ = global.jQuery = jQuery;
global.InitChat = InitChat;

const loanApplication = document.getElementById('loan-application-form');

if (loanApplication) {
  new Vue({
    el: loanApplication,
    components: { LoanApplicationForm },
    render: function (createElement) {
      return createElement(LoanApplicationForm, {
        props: {
          options: JSON.parse(this.$el.dataset.options),
          translations: JSON.parse(this.$el.dataset.translations),
          links: JSON.parse(this.$el.dataset.links),
        }
      });
    }
  })
}

$(document).foundation({
  accordion: {
    multi_expand: false,
  }
});

// Follow links inside accordions that don't have a hash href.
// This is needed for side navigation on service pages to work.
$(document).on('click', '[data-accordion]', function (event) {
  const target = event.target;
  if (!target.hash && target.href) {
    window.location = target.href;
  }
});

$(document).on('change', '.locale-picker select', function (event) {
  const target = event.target;
  if (target.value) {
    window.location = target.value;
  }
});

tippy('.has-tooltip', {
  content: e => {
    return e.dataset.content;
  },
  arrow: true,
  theme: 'light',
});


